import FilterItem from "./FilterItem.vue";
import TargetingTypeFilterBody from "./bodies/TargetingTypeFilterBody.vue";
import TextValue from "@/components/tableElements/TextValue.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
import { truncateString } from "@/utils";
export default {
  name: "TargetingTypeFilter",
  components: {
    FilterItem,
    TargetingTypeFilterBody,
    TextValue
  },
  emits: ["apply"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    targeting_types: {
      type: Object,
      required: true,
      default: () => ({
        filterState: {
          selected: [],
          list: []
        },
        isModified: false,
        select: () => {},
        deselect: () => {},
        clear: () => {},
        apply: () => {},
        listSearch: () => {}
      })
    },
    title: {
      type: String,
      default: "Targeting type"
    }
  },
  data() {
    return {
      icons: {
        DEFAULT: 'EqualsIcon',
        EXACT: 'TargetIcon',
        TARGETING_EXPRESSION: 'BracketsPlusIcon',
        TARGETING_EXPRESSION_PREDEFINED: 'BracketsCheckIcon',
        BROAD: 'ZoomOutIcon',
        PHRASE: 'MessageSquareIcon'
      }
    };
  },
  computed: {
    getTargetingTypeTitle() {
      return this.getTargetingType?.name ?? this.title;
    },
    getTargetingType() {
      return this.targeting_types.selected?.[0];
    },
    getTargetingTypeSelectedTitle() {
      const joined = this.targeting_types.selected?.map(el => el?.name).join(", ");
      return joined ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    onClear() {
      this.targeting_types.clear();
    },
    onRestoreSearch() {
      this.targeting_types.restoreSearch();
    },
    onSelect({
      key
    }) {
      this.targeting_types.select({
        key
      }, 'key');
    },
    onSelectOnly({
      key
    }) {
      this.targeting_types.selectOnly({
        key
      }, 'key');
    },
    onDeselect({
      key
    }) {
      this.targeting_types.deselect({
        key
      }, 'key');
    },
    onSearch({
      value
    }) {
      this.targeting_types.listSearch(value, ['name']);
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.targeting_types.clearDraft();
    },
    onHidden() {
      this.targeting_types.clearDraft();
    },
    onApply() {
      this.$emit('apply');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.targetingTypeFilterItem, initializer, callback);
    }
  }
};